import React, { Component } from "react";
import { connect } from "react-redux";
import Steps from "./Steps";
import Input from "../../../../shared/Input/Input";
import Select from "./../../../../shared/Select/Select";
import { getBanks, hasBank, sendCreateUpdateBank } from "../../../shared/requests-api";
import { isAllFieldsEmpty, returnUserJWT, getUserToken } from "../../../shared/utils";
import Modal from "../../../../shared/Modal/Modal";


class RegisterBankDetails extends Component {
	constructor() {
		super();
		this.state = {
			banks: [],
			errors: {
				agency: undefined,
				account: undefined,
				dacAccount: undefined
			}
		};

		this.submitAndNextStep = this.submitAndNextStep.bind(this);
		this.saveAndPrevStep = this.saveAndPrevStep.bind(this);
		this.validForm = this.validForm.bind(this);
		this.confirmNextStep = this.confirmNextStep.bind(this);
		this.selectBankOption = this.selectBankOption.bind(this);
	}

	componentDidMount() {
		const self = this;
		const { form, banks } = this.props;

		if (form) {
			this.setState(form);
		}

		const user = returnUserJWT();
		if (user) {
			this.setState({ cpfcnpj: user.ssn });
		}

		if (banks) {
			let banksMap = banks.map(bank => {
				return { value: bank.idBank, label: bank.name };
			});
			self.setState({
				banks: banksMap
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		const self = this;
		const { form, banks } = nextProps;

		if (form) {
			this.setState(form);
		}

		const user = returnUserJWT();
		if (user) {
			this.setState({ cpfcnpj: user.ssn });
		}

		if (banks) {
			let banksMap = banks.map(bank => {
				return { value: bank.idBank, label: bank.name };
			});
			self.setState({
				banks: banksMap
			});
		}
	}

	submitAndNextStep() {
		const token = getUserToken();
		const { bank, agency, dacAgency, account, dacAccount, cpfcnpj } = this.state;
		let self = this;

		self.setState({ loadingMessage: "Estamos salvando os dados..." });
		sendCreateUpdateBank(token, bank, agency, dacAgency, account, dacAccount, cpfcnpj)
			.then(response => {
				self.props.next(self.state);
			})
			.catch(response => {
				console.log(response);
				self.setState({ loadingMessage: response.data.message });
			});
	}

	saveAndPrevStep() {
		this.props.prev(this.state);
	}

	validForm(event) {
		const { errors } = this.state;
		let value = event.target.type == "checkbox" ? event.target.checked : event.target.value;

		if (event.target.name == "account") {
			value = value.replace(/\D/g, "");
		}

		if (event.target.name == "agency") {
			value = value.replace(/\D/g, "");
			this.moveOnMax(event, "dacAgencyId");
		}

		if (event.target.name == "dacAccount") {
			value = value.replace(/[^0-9xX]/g, "");
		}

		if (event.target.name == "dacAgency") {
			value = value.replace(/[^0-9xX]/g, "");
		}

		errors[event.target.name] = value
			? ""
			: `${event.target.title || event.target.name} não confere`;

		this.setState({ [event.target.name]: value, errors });
	}

	isValid = () => {
		const { agency, bank, bankOption, account, dacAccount, dacAgency, errors } = this.state;

		let valid =
			agency &&
			bankOption &&
			dacAccount &&
			account &&
			isAllFieldsEmpty(errors, "agency", "dacAccount", "account");

		if (bank == 45 && valid) {
			valid = dacAgency && isAllFieldsEmpty(errors, "dacAgency");
		}

		return valid;
	};

	confirmNextStep() {
		const {
			bankOption,
			agency,
			bank,
			account,
			cpfcnpj,
			errors,
			dacAccount,
			dacAgency
		} = this.state;
		if (!this.isValid()) {
			if (cpfcnpj == "" || cpfcnpj == undefined) {
				errors.cpfcnpj = "Campo obrigatório";
			}
			if (dacAccount == "" || dacAccount == undefined) {
				errors.dacAccount = "Campo obrigatório";
			}
			if (account == "" || account == undefined) {
				errors.account = "Campo obrigatório";
			}
			if (agency == "" || agency == undefined) {
				errors.agency = "Campo obrigatório";
			}
			if (!bankOption) {
				errors.bankOption = "Campo obrigatório";
			}
			if (bank == 45) {
				if (dacAgency == "" || dacAgency == undefined) {
					errors.dacAgency = "Campo obrigatório";
				}
			}
			this.setState({ errors });
		} else {
			this.submitAndNextStep();
		}
	}

	selectBankOption(bankOption) {
		const { errors } = this.state;
		errors.bankOption = "";
		this.setState({ bankOption, bank: bankOption.value, errors });
	}

	moveOnMax(event, nextFieldID) {
		const { bank } = this.state;
		if (bank == 45) {
			let value = event.target.value;
			if (value.length >= event.target.maxLength) {
				document.getElementById(nextFieldID).focus();
			}
		}
	}

	render() {
		const { prev } = this.props;
		const {
			banks,
			bankOption,
			agency,
			bank,
			account,
			cpfcnpj,
			errors,
			dacAccount,
			dacAgency,
			loadingMessage,
			showLoading
		} = this.state;

		return (
			<section className="register-bank-details row no-margin">
				<form className="form-offer block-center" onChange={this.validForm}>
					<div className="col-xs-16 text-center hidden-xs">
						<span className="form-offer--title">
							Dados Bancários
							<span className="form-offer--title--subtitle">
								Precisamos dos seus dados bancários para realizar o pagamento das vendas feitas por
								você na MaxMilhas. <br />
								<strong>Mas, atenção!</strong> O titular da conta bancária deve ser o mesmo titular
								das milhas. Combinado?
							</span>
						</span>
					</div>
					<div className="row">
						<div className="col-xs-16 col-md-6 form-group">
							<Input
								className="account-bank-details--input--document"
								label="CPF/CNPJ"
								placeholder="XXX.XXX.XXX-XX"
								name="cpfcnpj"
								disabled
								value={cpfcnpj}
								data-action="register-bank-details-cpfcnpj"
							/>
						</div>
						<div className="col-xs-16 col-md-5 form-group">
							<label className="account-bank-details--label" htmlFor="bank-select">Banco*</label>
							<Select
								id="bank-select"
								selected={bankOption}
								errorMessage={errors.bankOption}
								onChange={bankOption => this.selectBankOption(bankOption)}
								options={banks}
								name="bank"
								data-action="register-bank-details-bank-select"
								hasSearch={true}
							/>
						</div>
					</div>
					<div className="row">
						<div
							className={`${
								bank == 45 ? "col-xs-12 col-md-6 agency" : "col-xs-16 col-md-8"
							} form-group`}
						>
							<Input
								label="Agência*"
								placeholder="Inserir sua agência"
								name="agency"
								required
								value={agency}
								pattern="\d*"
								inputMode="numeric"
								errorMessage={errors.agency}
								maxLength="4"
								id="agencyId"
								data-action="register-bank-details-agency"
							/>
						</div>
						{bank == 45 && (
							<div className="col-xs-4 col-md-2 form-group digit">
								<Input
									label="Dígito*"
									placeholder="0"
									name="dacAgency"
									maxLength="1"
									required
									value={dacAgency}
									pattern="\d*"
									inputMode="numeric"
									errorMessage={errors.dacAgency}
									id="dacAgencyId"
									data-action="register-bank-details-agency-digit"
								/>
							</div>
						)}

						<div className="col-xs-12 col-md-6 form-group account">
							<Input
								label="Conta corrente*"
								placeholder="Inserir sua conta"
								name="account"
								required
								value={account}
								pattern="\d*"
								inputMode="numeric"
								maxLength="18"
								errorMessage={errors.account}
								data-action="register-bank-details-account"
							/>
						</div>
						<div className="col-xs-4 col-md-2 form-group digit">
							<Input
								label="Dígito*"
								placeholder="0"
								name="dacAccount"
								maxLength="1"
								required
								value={dacAccount}
								pattern="\d*"
								inputMode="numeric"
								errorMessage={errors.dacAccount}
								data-action="register-bank-details-account-digit"
							/>
						</div>
					</div>
				</form>

				<Steps
					prev={this.saveAndPrevStep}
					next={this.confirmNextStep}
					canPrev={true}
					canNext={true}
				/>

				<Modal
					title="DADOS BANCÁRIOS"
					description={loadingMessage}
					show={showLoading}
					confirm="Fechar"
					onConfirm={() => this.setState({ showLoading: false })}
				/>
			</section>
		);
	}
}

const mapStateToProps = state => ({
	banks: state.createOffer.banks
});

export default connect(mapStateToProps)(RegisterBankDetails);
